import { catchJSException } from './../logService';
import { InHomeUtils } from './../../util/inhomeUtils';
import { updateSCTags, getProductObject, getPrdName, calcprdBasePrice, getVasCategory, prdCategoryInfo} from './dtmTag';
import {store} from './../../index'
import { Service } from './../../constants/actionType'

var vzdl = require('./vzdlData.json');
var cartCount = 0;
var cartPreviousCount = 0;
var isFirstCartAdd = true;
let subFlowChange = 'none';
let isProdView = false;
let currProductsArray = [];
let isPegaViewAllFlag = false;
const shaKey ='TWoOwIsECMenIFOunDR97WMounTAIns8anD2A3DiaMOndYbUR15dCunderHN0rtHKELop';
let targetMessageFlag = false;
//var isPegaFirstEventcalled = false;

const updatePageFlowForDisconnectFlow = () =>{
    vzdl.page.flow = (store?.getState().buildProduct &&
    store?.getState().signIn?.response?.flowRoute === "FULLDISCONNECT" ) ? 
    vzdl.page?.flow?.includes("  Disconnect Flow") ?
    vzdl.page?.flow : (vzdl.page?.flow  + " &#124;"+ '  Disconnect Flow') : vzdl.page?.flow; 
}

const getProductCurrentId = (category) =>{
    let idList = '';
    Array.isArray(vzdl?.txn?.product?.current) && vzdl?.txn?.product?.current?.forEach((item) => {
        if(item?.category?.indexOf(category) !== -1){
            idList = item?.id != '' ? (idList + item?.id + '|') : "";
        }
    });
    return idList;
}

const generateValueBayouCombo = () => {
    if(!window.location.href.includes('buildproducts')){
        let isocIds = '';
        let vzdlCartResponse =  store && store.getState() && store.getState()?.cart?.cartResponse;
        if (vzdlCartResponse?.tierContent) {
            vzdlCartResponse?.tierContent?.[0]?.sections?.section?.map((cartsections) => {

                if (cartsections.sectionName == "Service" ||  cartsections.sectionName == "Perks") {
                    
                    cartsections.subSections.subSection.map((cartsubsection) => {

                        if (cartsubsection.sectionType == "DATASTANDALONE") {

                            cartsubsection?.products.map((product) => {
                                
                                if ((product.prodType === "FTTPD") && !isocIds.includes(product.prodId) ) {
                                    isocIds = isocIds + product.prodId + '|'
                                }
                            });
                        }
                        else if(cartsubsection.sectionType == "Perks"){
                            cartsubsection?.products.map((product) => {
                                
                                if (!isocIds.includes(product.prodId) ) {
                                    isocIds = isocIds + product.prodId + '|'
                                }
                            });
                        }
                    });
                }
            })
        }
        // updating bayouCombo if the current item is not in cart response
        Array.isArray(vzdl?.txn?.product?.current) && vzdl?.txn?.product?.current?.forEach((currentItem) => {
            let productMerchCat = currentItem?.merchCat;
            if ((['plan', 'perks'] .includes(productMerchCat)) && (isocIds.indexOf(currentItem.id)) === -1) {
                isocIds = isocIds + currentItem.id + '|'
            }
        });
        vzdl.txn.bayouCombo =  isocIds?.substring(0, isocIds?.length - 1) ?? "";
    }
}


let merchVariables =  {};

const getMerchPropsFromMN = () => {
    const buildProduct = store && store.getState && store.getState().buildProduct;
    const selectedInternet = buildProduct && buildProduct.internet.selectedProduct;
    const selectedPerks = buildProduct?.perks?.selectedProduct?.length > 0 ? buildProduct?.perks?.selectedProduct : [];
    const perkTitles = selectedPerks?.map(perk => perk?.accordionTitle)?.join('|')
    if (buildProduct?.isMNEnabled) {
        merchVariables = {
            path: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'custom' : (buildProduct?.isPopularPlan ? 'popular' : 'recommended'),
          //  merchPath: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'custom' : (buildProduct?.isPopularPlan ? 'popular' : 'recommended'),
            action: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'customized' : (buildProduct?.isPopularPlan ? 'preset' : 'modify'),
          //  merchAction: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'customized' : (buildProduct?.isPopularPlan ? 'preset' : 'modify')
        }
        return merchVariables;
    } else {
        if ((selectedInternet?.name || selectedPerks?.length > 0)) {
            merchVariables = {
                path: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'custom' : (buildProduct?.isPopularPlan ? 'popular' : 'recommended'),
             //   merchPath: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'custom' : (buildProduct?.isPopularPlan ? 'popular' : 'recommended'),
                action: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'customized' : (buildProduct?.isPopularPlan ? 'preset' : 'modify'),
                //merchAction: !(buildProduct?.isPopularPlan || buildProduct?.isCustomizeFromPP) ? 'customized' : (buildProduct?.isPopularPlan ? 'preset' : 'modify')
            };
            return merchVariables;
        }
    }
    return {
        merchCat: "",
        path: "",
        action: ""
    };
}
export const getOmniInit = (pageInfo, stateInfo) => {
    try {
        window.vzdl = vzdl;
        //VCGBQA-1804 - removing event 138 and 139
        vzdl.event.value = "";
        defaultEventUpdates("pageViewOmni", pageInfo, stateInfo);
        vzdl.env.businessUnit = "Wireline";
        let isACPFlag = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.isACPFlag ? true : false;
        let isMnhEligible = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.isMnhOfferElligble ? true : false;
        let getRoute =  store.getState().buildProduct && store.getState().signIn?.response?.flowRoute
        //let leadList = store.getState().buildProduct && store.getState().signIn?.response?.marketingProfileLeadListId ? true : false
        let mNmLeadList =  store.getState().signIn &&  store.getState().signIn.response &&  store.getState().signIn?.response?.marketingProfileLeadListId?.split(',')?.filter((listId) => listId == "LC10000864")?.length;
         let getRetentionOfferObject = store.getState().disconnectvalues?.retentionOfferResponse;
         
        const isvzfwFlag = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isVZFwdFlag;
        const isVzfwdNyOffer = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isVzfNYDiscount;  
         updatePageFlowForDisconnectFlow();        

        if(isACPFlag){
            vzdl.target.message = 'You qualify for the affordable connectivity program discount';
            targetMessageFlag = true;
        }
        if(getRoute =="FULLDISCONNECT" ){   
            vzdl.target.message = (mNmLeadList  &&  getRetentionOfferObject?.offerApplied) ? "Want to stay a Verizon Customer and Get $10/mo off home internet?" :"You may be eligible for a discount or other offers" 
            targetMessageFlag = true; 
        }
        if(isvzfwFlag && window.location?.pathname?.includes('/change/buildproducts')){
            targetMessageFlag=true
            const vzfwdBppMsg= `You are eligible for Verizon Forward${ isVzfwdNyOffer ? ' - NY': '' }. Choose an eligible plan to add the discount.`
            vzdl.target.message = vzfwdBppMsg
            vzdl.page.contentFragments=vzfwdBppMsg;
         }
        if (InHomeUtils.isNotNull(window) && InHomeUtils.isNotNull(window.cookie)) {
            let adbidArray = window.cookie.split(";").filter(each => each.includes("adbid="))[0]
            let adbid = adbidArray && adbidArray.split("=")[1]
            vzdl.user.account = adbid
        }
        if((InHomeUtils.isNotNull(stateInfo.stateInfo.signIn)) && (InHomeUtils.isNotNull(stateInfo.stateInfo.signIn.response))){
            if(stateInfo.stateInfo.signIn.response.vZWvZTCustIndicator || stateInfo.stateInfo.signIn.response.isVZWWireless == "Y"){
               vzdl.event.value=vzdl.event.value+ ",event9";
            }

        }
        if(InHomeUtils.isNotNull(pageInfo) && pageInfo === "legacyToVMSConfirmation"){
            vzdl.event.value = "purchase,event116";
            vzdl.page.name = "Order confirmation";
            vzdl.page.detail = "Legacy To VMS Confirmation";
        }
        else if(InHomeUtils.isNotNull(pageInfo) && pageInfo === "conflictmessage"){
            vzdl.page.name = "affinity eligibility info";
            vzdl.page.detail = "conflict message";
            updateSubFlowValue('| byob', 'byob');
        }
        else if(InHomeUtils.isNotNull(pageInfo) && pageInfo === "empConfirm"){
            vzdl.page.name = "affinity eligibility info";
            vzdl.page.detail = "ultimate employees eligibility info - emp confirmation";
            updateSubFlowValue('| byob', 'byob');
        }
        else if(InHomeUtils.isNotNull(pageInfo) && pageInfo === "lboInit"){
            if(window?.location?.search && window.location.search.toLowerCase().includes("ruralbroadband")){
                vzdl.page.name = "lbo redesign";
                vzdl.target.message = "To upgrade or make a change to your Fios account, please contact us. Call us at 866.909.2198";
                targetMessageFlag = true;
            }
            else{
                vzdl.page.name = "lbo";
            }

        }
        if(isPegaViewAllFlag){
            vzdl.event.value= vzdl.event.value + "scOpen,scAdd";
            isPegaViewAllFlag = false;
        }
        sendCustomEvent("pageViewOmni");
        if(isMnhEligible && !vzdl.page.subFlow?.includes('M+H')) {
            vzdl.page.subFlow=  vzdl.page.subFlow ? vzdl.page.subFlow + ' | M+H' : 'M+H'
        }
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'getOmniInit', "getOmniInit:" + ex);
    }
}

export const getCheckoutInit = (StateInfo) => {
    try {
        updatePageFlowForDisconnectFlow();
        //PRODDEF-39046 - Restricting txn.id to be populated only for order confirmation page
        vzdl.txn.id = "";
        /*if (InHomeUtils.isNotNull(StateInfo.stateInfo.appState) && InHomeUtils.isNotNull(StateInfo.stateInfo.appState.mon_no) && StateInfo.stateInfo.appState.mon_no != "")
            vzdl.txn.id = StateInfo.stateInfo.appState.mon_no;
        else if(InHomeUtils.isNotNull(StateInfo.stateInfo.signIn) && InHomeUtils.isNotNull(StateInfo.stateInfo.signIn.response) && InHomeUtils.isNotNull(StateInfo.stateInfo.signIn.response.mon))
            vzdl.txn.id = StateInfo.stateInfo.signIn.response.mon;*/
        let isvzfwFlag = StateInfo.stateInfo?.buildProductState?.isVZFwdFlag
        let isVzfwdNyOffer = StateInfo.stateInfo?.buildProductState?.isVzfNYDiscount
        let isClassic = !StateInfo.stateInfo?.signIn.response?.userProfile?.isFcpInProfile && !StateInfo.stateInfo?.signIn?.response?.classicToFcp ;
        vzdl.txn.cartId = vzdl.txn.id; // VCGBQA-1465 - fix
        vzdl.txn.paymentType = InHomeUtils.isNotNull(StateInfo.stateInfo) && InHomeUtils.isNotNull(StateInfo.stateInfo.checkout) && InHomeUtils.isNotNull(StateInfo.stateInfo.checkout.paymentmodeSelection) && InHomeUtils.isNotEmpty(StateInfo.stateInfo.checkout.paymentmodeSelection) ? StateInfo.stateInfo.checkout.paymentmodeSelection : "";
        vzdl.txn.installOptions = InHomeUtils.isNotNull(StateInfo.stateInfo) && InHomeUtils.isNotNull(StateInfo.stateInfo.checkout) && InHomeUtils.isNotNull(StateInfo.stateInfo.checkout.selDueDateType) && InHomeUtils.isNotEmpty(StateInfo.stateInfo.checkout.selDueDateType) ? StateInfo.stateInfo.checkout.selDueDateType : "";
        let dtmProdArr = getProductObject(StateInfo.stateInfo.cart.cartOrderDetail, StateInfo.stateInfo.cart.cartResponse, "AF");
        vzdl.txn.product.current = getVzdlCurrentProduct(dtmProdArr);
        generateValueBayouCombo();
        vzdl.page.name = "checkout";
        vzdl.page.flow = "acrdflow/am";
        vzdl.event.value = "scCheckout, event146";
        vzdl.env.businessUnit = "Wireline";
        vzdl.target.sandbox = "";
        let vfMessage= "";
        if(isvzfwFlag){
                if(isClassic) {
                    vfMessage =`You are qualified for the Verizon Forward${isVzfwdNyOffer ? ' - NY': '' }. Switch plans to be eligible.`
                }else{
                    vfMessage=`You have qualified for the Verizon Forward${isVzfwdNyOffer ? ' - NY': '' }. Place order to add the discount to your account.`;
                } 
                updateSubFlowValue('| vfwd', 'vfwd')
                targetMessageFlag=true
                vzdl.page.detail = "message displayed"
                vzdl.target.campaign="vf3-checkout-continue" 
                vzdl.target.message=vfMessage;
                vzdl.page.contentFragments=vfMessage;
        }
       
        if (StateInfo.stateInfo != undefined && StateInfo.stateInfo.checkout != undefined && StateInfo.stateInfo.checkout.accordionStatus != undefined) {
            let accordionStatus = StateInfo.stateInfo.checkout.accordionStatus;
            if (accordionStatus.returnEquipment == "completed"
                && accordionStatus.disconnect == "completed"
                && accordionStatus.autoPay == "completed"
                && accordionStatus.installation == "completed") {
                vzdl.page.detail = "review order|terms of service";
            }
            else if (accordionStatus.returnEquipment == "completed"
                && accordionStatus.disconnect == "completed"
                && accordionStatus.autoPay == "completed") {
                if (StateInfo.stateInfo.checkout.satelliteEligible === "Y" && !StateInfo.stateInfo.checkout.satelliteClick)
                    vzdl.page.detail = "Satellite|terms of service";//"Installation";
                else
                    vzdl.page.detail = "Installation|terms of service";//"Installation";
            }
            else if (accordionStatus.returnEquipment == "completed"
                && accordionStatus.disconnect == "completed") {
                vzdl.page.detail = "Paper Free Billing & Auto pay|terms of service";
            }
            else if (accordionStatus.returnEquipment == "completed") {
                vzdl.page.detail = "Disconnect|terms of service";
            }
            else {
                if (StateInfo.stateInfo.cart && StateInfo.stateInfo.cart.isShippingFee && StateInfo.stateInfo.lqState && StateInfo.stateInfo.lqInfo.runtimeKey.iscrpenable === 'Y') {
                    vzdl.page.detail = "Getting New Equipment|terms of service";
                }else if(StateInfo.appState.flowRoute ==="FULLDISCONNECT"){
                    vzdl.page.name = "checkout"
                }
                else
                    vzdl.page.detail = "Return Equipment|terms of service";
            }
        }
        populatingSessionVzdlObjects(StateInfo.stateInfo?.buildProductState?.ecCheckoutNew)
        sendCustomEvent('Checkout');
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'getCheckoutInit', "getCheckoutInit:" + ex);
    }
}

export const CheckoutPageEvent = (pageName, stateInfo) => {
    try {
        let getRoute =  store.getState().buildProduct && store.getState().signIn?.response?.flowRoute
        let accordionStatus = stateInfo.accordionStatus;

        updatePageFlowForDisconnectFlow();

        if (pageName == "disconnect"){
            vzdl.page.name = "checkout"
            vzdl.page.detail = "Disconnect Date";
            vzdl.page.event = "";
        }
        if (pageName == "returnEquipment") {
            if(getRoute === "FULLDISCONNECT"){
                vzdl.page.name = "checkout"
                vzdl.page.detail = "returning equipment" 
            }
          
            if (stateInfo != undefined && stateInfo.accordionStatus != undefined) {
                let accordionStatus = stateInfo.accordionStatus;
                if (accordionStatus.disconnect == "completed"
                    && accordionStatus.autoPay == "completed"
                    && accordionStatus.installation == "completed") {
                    vzdl.page.detail = getRoute === "FULLDISCONNECT" ? "returning equipment" : "review order";vzdl.page.detail = "review order";
                }
                else if (accordionStatus.disconnect == "completed"
                    && accordionStatus.autoPay == "completed"
                    && accordionStatus.satellite == "completed") {
                    //if (stateInfo.satelliteEligible != undefined && stateInfo.satelliteEligible === "Y" && !stateInfo.satelliteClick)
                    vzdl.page.detail = "Installation";
                }
                else if (accordionStatus.disconnect == "completed"
                    && accordionStatus.autoPay == "completed") {
                    vzdl.page.detail = "Satellite";
                }
                else if (accordionStatus.disconnect == "completed") {
                    vzdl.page.detail = "Paper Free Billing & Auto pay";
                }
            }
        }
        if (pageName == "PFBAutopay") {
            if (stateInfo != undefined && stateInfo.accordionStatus != undefined) {
                let accordionStatus = stateInfo.accordionStatus;
                if (accordionStatus.returnEquipment == "completed"
                    && accordionStatus.disconnect == "completed"
                    && accordionStatus.autoPay == "completed"
                    && accordionStatus.installation == "completed") {
                    vzdl.page.detail = "review order";
                }
                else if (accordionStatus.returnEquipment == "completed"
                    && accordionStatus.disconnect == "completed"
                    && accordionStatus.autoPay == "completed") {
                    if (stateInfo.satelliteEligible != undefined && stateInfo.satelliteEligible === "Y" && !stateInfo.satelliteClick)
                        vzdl.page.detail = "Satellite";
                    else
                        vzdl.page.detail = "Installation";
                }
            }
        }
        if (pageName == "satellite") {
            vzdl.page.detail = "Installation";
        }
        if (pageName == "Installation") {
            vzdl.page.detail = "review order";
        }
        vzdl.env.businessUnit = "Wireline";
        sendCustomEvent('pageViewOmni');
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'CheckoutPageEvent', "CheckoutPageEvent:" + ex);
    }
}

export const updateFlowName = val => {
    if(val)
    {
        vzdl.page.flow = val;
    }
    else if(!val)
    {
        vzdl.page.flow = '';
    }
}
export const updateDetailValue = val => {
    if(val)
    {
        vzdl.page.detail = val;
    }
    else if(!val)
    {
        vzdl.page.detail = '';
    }
}

export const vzdlErrorUpdate = (code, msg) => {
    if (vzdl && vzdl.error && vzdl.error.code !== "") {
        vzdl.error.code = `${vzdl.error.code}^${code}|${msg}`;
    }
    else if (vzdl && vzdl.error && vzdl.error.code) {
        vzdl.error.code = `${code}|${msg}`;
    }
    else if (vzdl && vzdl.error.code === "") {
        vzdl.error.code = code | msg;
    }
    sendCustomEvent('pageViewOmni');
}

const defaultEventUpdates = (eventName, pageInfo, stateInfo) => {
    // let initData = scVzdlDataDetails[pageInfo];
    // let dtmdomainurl = window.location.href.toLowerCase();
    // let flowName = dtmdomainurl.indexOf("/clu") !== -1 ? "" : "prospect accord";
    // let sflowName = getFlowName(stateInfo, pageInfo, flowName);
    // flowName = sflowName;

    try {
        populatingVzdlUserObject(stateInfo);
        populatingVzdlTxnObject(stateInfo);
        populatingVzdlPageObject(stateInfo);
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'defaultEventUpdates', "defaultEventUpdates:" + ex);
    }

}
export const updateSandboxIdValue = (val = "") => {
    if(val)
    {
        if(vzdl.target.sandbox === '')
        vzdl.target.sandbox = val;
        else if(vzdl.target.sandbox.indexOf(val) !== -1)
            vzdl.target.sandbox = vzdl.target.sandbox;
        else 
        vzdl.target.sandbox = vzdl.target.sandbox+ '| '+ val;
    } 
}

export const populatingSessionVzdlObjects = (ecCheckoutNew) => {
        if(window.sessionStorage && vzdl.target.sandbox === '')
        {
            if(window.sessionStorage.urccheckout === 'true' || window.sessionStorage.urccheckout || ecCheckoutNew ){  
                updateSandboxIdValue(ecCheckoutNew ? 'fios_co':'fios_u_co');
            }
            else {
                updateSandboxIdValue('fios_u_co');            
            }          
        } 
}
const populatingVzdlPageObject = (stateInfo, pageInfo, flowName, initData) => {
    try {
        if (stateInfo.stateInfo.signIn != undefined) {
            //vzdl.page.subFlow = vzdl.page.subFlow === "pega" ? vzdl.page.subFlow : "";
            //stateInfo.stateInfo.signIn.response.classicToFcp == true ? "mix match" : stateInfo.stateInfo.signIn.response.userProfile.isFcpInProfile == true ? "mix match" : "Classic";
            vzdl.page.LQZip = stateInfo.stateInfo.signIn.response.zipCode;
        }
        let isACPFlag = store && store.getState && store.getState().buildProduct && store.getState().buildProduct.isACPFlag ? true : false;
        let isvzfwFlag = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isVZFwdFlag?true:false;
        let isClassic = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isClassicAccount ? true : false ;
        const isVzfwdNyOffer = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct?.isVzfNYDiscount;
       
        if(isACPFlag){
            updateSubFlowValue('| acp', 'acp')
        }
        if(isvzfwFlag){
            updateSubFlowValue('| vfwd', 'vfwd')
        }
        //console.log("bhushan page stateInfo", stateInfo);  
        if (stateInfo.stateInfo.appState != undefined) {
            vzdl.page.channelSession = stateInfo.stateInfo.appState.visitId;
        }
        vzdl.page.detail = ""; //populate blank for other calls //overlay (popup) value ... common function is created for all overlay populateVZDLoverlayName
        vzdl.page.flow = "acrdflow/am";
        vzdl.page.name = "Service Overview";
        vzdl.page.throttle = "";
        vzdl.page.contentFragments = "";
        vzdl.page.link = "";
        if(isvzfwFlag && window.location?.pathname?.includes('/change/buildproducts')){
            targetMessageFlag=true
            const vzfwdBppMsg= `You are eligible for Verizon Forward${ isVzfwdNyOffer ? ' - NY': '' }. Choose an eligible plan to add the discount.`
            vzdl.target.message = vzfwdBppMsg
            vzdl.page.contentFragments=vzfwdBppMsg;
         }
        updatePageFlowForDisconnectFlow();     
        // vzdl.page.accBundleFlag = "";
        // vzdl.page.cpcFlag = "";
        // vzdl.page.deviceDollarsApplied = "";
        // vzdl.page.wishListFlag = "";  
           
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'populatingVzdlPageObject', "populatingVzdlPageObject:" + ex);
    }
}

const populatingVzdlTargetObject = (stateInfo, pageInfo, flowName, initData) => {
    vzdl.target.assetsRequested = "",
        vzdl.target.assetAttributes = "",
        vzdl.target.assetsLeveraged = "",
        vzdl.target.abTest = "",
        vzdl.target.campaign = "",
        vzdl.target.experience = "",
        vzdl.target.message = "",
        vzdl.target.offer = "",
        vzdl.target.cloud = "",
        vzdl.target.mktgId = "",
        vzdl.target.sandBox = {
            "intent": "",
            "id": "",
            "offered": ""
        }
}
const populatingVzdlTxnObject = (stateInfo) => {
    try {
        //vzdl.txn.agent = "",
        //vzdl.txn.productsQualified = serviceQualified;
        if(stateInfo && InHomeUtils.isNotNull(stateInfo.stateInfo)){
            if (InHomeUtils.isNotNull(stateInfo.stateInfo.profileCart) && InHomeUtils.isNotNull(stateInfo.stateInfo.profileCart.cartData) && Array.isArray(stateInfo.stateInfo.profileCart.cartData) && stateInfo.stateInfo.profileCart.cartData.length > 0) {
                vzdl.txn.product.owns = getOwnCart(stateInfo);
            }
            if (InHomeUtils.isNotNull(stateInfo.stateInfo.cart) && InHomeUtils.isNotNull(stateInfo.stateInfo.cart.autoPayinCart))
                vzdl.txn.autoPay = stateInfo.stateInfo.cart.autoPayinCart == true ? "Y" : "N";
            if (InHomeUtils.isNotNull(stateInfo.stateInfo.signInState) && InHomeUtils.isNotNull(stateInfo.stateInfo.signInState.response) && InHomeUtils.isNotNull(stateInfo.stateInfo.signInState.response.zipCode))
                vzdl.txn.shippingZip = stateInfo.stateInfo.signInState.response.zipCode;//wrong
            else if (InHomeUtils.isNotNull(stateInfo.stateInfo.signIn) && InHomeUtils.isNotNull(stateInfo.stateInfo.signIn.response) && InHomeUtils.isNotNull(stateInfo.stateInfo.signIn.response.zipCode))
                vzdl.txn.shippingZip = stateInfo.stateInfo.signIn.response.zipCode;//wrong
            //stateInfo.stateInfo.signIn.response.billingAddress.zip;//correct
            //vzdl.txn.product.current = getCurrentCart(stateInfo);   
            //PRODDEF-39046 - Restricting txn.id to be populated only for order confirmation page
            if(window.location.href.includes('/summary')){
                if (InHomeUtils.isNotNull(stateInfo.stateInfo.appState) && InHomeUtils.isNotNull(stateInfo.stateInfo.appState.mon_no) && stateInfo.stateInfo.appState.mon_no != "")
                    vzdl.txn.id = stateInfo.stateInfo.appState.mon_no;
                else if(InHomeUtils.isNotNull(stateInfo.stateInfo.signIn) && InHomeUtils.isNotNull(stateInfo.stateInfo.signIn.response) && InHomeUtils.isNotNull(stateInfo.stateInfo.signIn.response.mon))
                    vzdl.txn.id = stateInfo.stateInfo.signIn.response.mon;
            }
            else{
                vzdl.txn.id = "";
            }
            if(stateInfo.stateInfo.cart && stateInfo.stateInfo.cart?.cartOrderDetail && stateInfo.stateInfo.cart?.cartResponse){
                let dtmProdArr = getProductObject(stateInfo.stateInfo.cart.cartOrderDetail, stateInfo.stateInfo.cart.cartResponse, "AF");
                vzdl.txn.product.current = getVzdlCurrentProduct(dtmProdArr);
                vzdl.event.value= "event86," +vzdl.event.value;
                generateValueBayouCombo();
            }
        }
        vzdl.txn.cartId = vzdl.txn.id; // VCGBQA-1465 - fix
        vzdl.txn.paymentType = "";//this is will only on checkout
        vzdl.txn.installOptions = "";//this is will only on checkout
        vzdl.txn.taxAmt = "";//(CalcTaxAmount(stateInfo.stateInfo)).toString();  
        vzdl.txn.offer = "";
        // vzdl.txn.discountId = "",
        vzdl.txn.orderType = "urc";
        //generateValueBayouCombo();

        // vzdl.txn.status = "",
        // vzdl.txn.cartId = "",
        // vzdl.txn.outletId = "",
        // vzdl.txn.quoteid = "",        
        // vzdl.txn.shippingTotal = "",
        // vzdl.txn.shippingCharge = "",
        // vzdl.txn.tradeInQty = "",
        // vzdl.txn.tradeInAmt = "",                 
        // vzdl.txn.futurePayment = "",        
        // vzdl.txn.discount = "",
        // vzdl.txn.paymentAmt = "",        
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'populatingVzdlTxnObject', "populatingVzdlTxnObject:" + ex);
    }
}

const getOwnCart = (stateInfo) => {
    try {
        let cartData = stateInfo.stateInfo.profileCart.cartData[0];
        let promoProduct = [];
        let perkProducts = [];
        let channelsNotInPack = [];
        let equipmentProduct = [];
        let fiosFiveSelectedChannels = [];
        let listing = [];
        let oneTimeCharge = [];
        let removedServices = [];
        let removedequipments = [];
        let rewardOffers = [];
        let serviceHeaders = [];
        let youtubePrd = [];
        let streamService = [];
        if (cartData == undefined)
            return null;
        //---
        if (cartData.perks && cartData.perks.perks != undefined) {
            perkProducts = cartData.perks.perks.map((ownProduct) => {
                return {
                    name: ownProduct?.prodName,
                    id: ownProduct?.prodId,
                    category: ownProduct?.prodType,
                    recurringPrice: ownProduct.price,
                    line: null
                }
            });
        }
        //---
        if (cartData.Promotions && cartData.Promotions.promotions != undefined) {
            promoProduct = cartData.Promotions.promotions.map((ownProduct) => {
                return {
                    name: ownProduct.name,
                    id: ownProduct.id,
                    category: ownProduct.category,
                    recurringPrice: ownProduct.price,
                    line: null
                }
            });
        }
        if (cartData.channelsNotInPack && cartData.channelsNotInPack != undefined && cartData.channelsNotInPack.length > 0) {
            channelsNotInPack = cartData.channelsNotInPack.map((channelsNotInPackProduct) => {
                return {
                    name: channelsNotInPackProduct.name,
                    id: channelsNotInPackProduct.id,
                    category: channelsNotInPackProduct.category,
                    recurringPrice: channelsNotInPackProduct.price,
                    line: null
                }
            });
        }
        if (cartData.equipments && cartData.equipments.equipment != undefined) {
            equipmentProduct = cartData.equipments.equipment.map((equipmentProduct) => {
                return {
                    name: equipmentProduct.prodName,
                    id: equipmentProduct.prodId,
                    category: equipmentProduct.prodType,
                    recurringPrice: equipmentProduct.price,
                    line: null
                }
            });
        }
        if (cartData.fiosFiveSelectedChannels != undefined) {
            fiosFiveSelectedChannels = cartData.fiosFiveSelectedChannels.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.prodId,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.listing && cartData.listing.listingProds != undefined && cartData.listing.listingProds) {
            listing = cartData.listing.listingProds.map((listingProduct) => {
                return {
                    name: listingProduct.prodName,
                    id: listingProduct.id,
                    category: null,
                    recurringPrice: listingProduct.price,
                    line: null
                }
            });
        }
        if (cartData.oneTimeCharge != undefined) {
            oneTimeCharge = cartData.oneTimeCharge.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.id,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.removedServices != undefined) {
            removedServices = cartData.removedServices.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.id,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.removedequipments != undefined) {
            removedequipments = cartData.removedequipments.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.id,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.rewardOffers && cartData.rewardOffers.rewardOffers != undefined) {
            rewardOffers = cartData.rewardOffers.rewardOffers.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.id,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.serviceHeaders && cartData.serviceHeaders.servicehead != undefined) {
            serviceHeaders = cartData.serviceHeaders.servicehead.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.prodId,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.youtubePrd && cartData.youtubePrd.youtubePrd != undefined) {
            youtubePrd = cartData.youtubePrd.youtubePrd.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.prodId,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        if (cartData.streamService && cartData.streamService.streamServiceProds != undefined) {
            streamService = cartData.streamService.streamServiceProds.map((obj) => {
                return {
                    name: obj.prodName,
                    id: obj.prodId,
                    category: obj.prodType,
                    recurringPrice: obj.price,
                    line: null
                }
            });
        }
        return [].concat(perkProducts, promoProduct, channelsNotInPack, equipmentProduct, fiosFiveSelectedChannels, listing, oneTimeCharge, removedServices, removedequipments, rewardOffers, serviceHeaders, youtubePrd);
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'getOwnCart', "getOwnCart:" + ex);
    }
}

export const getVZDLCurrentCart = (currentCart, response) => {
    cartPreviousCount = cartCount;
    const currentProduct = getVzdlCurrentProduct(currentCart);
    vzdl.txn.product.current = currentProduct;
    generateValueBayouCombo();

    if (InHomeUtils.isNotNull(response)) {
        let cartData = response.data?.cartTierPricing?.tierContent?.[0];
        vzdl.txn.recurringCharges = cartData?.monthlyRcPrice;
        vzdl.txn.nonRecurringCharges = cartData?.totalNrcPrice;
        vzdl.txn.total = cartData?.totalMonthlyPrice;
        vzdl.txn.discount = "";
        // cartData.sections.section.map((cartsections, index) => {
        //     if (cartsections != null && cartsections.subSections != null && cartsections.subSections.subSection != null) {
        //         cartsections.subSections.subSection.map((cartsubsection, index) => {
        //             if (cartsubsection.promos != null) {
        //                 vzdl.txn.discount = InHomeUtils.isNotNull(cartsubsection.promos.sectionTotalprice) ? cartsubsection.promos.sectionTotalprice : InHomeUtils.isNotNull(cartsubsection.promos[0].price) ? cartsubsection.promos[0].price : "0";
        //             }
        //         })
        //     }
        // });
    }
    // if (cartData.sections.section.Promotions != undefined && cartData.Promotions != null && cartData.Promotions.length > 0) {
    //     vzdl.txn.discount = cartData.Promotions.promotions.map((obj) => {
    //         return obj.price;
    //     }).reduce((pv, cv) => {
    //         return parseFloat(pv) + parseFloat(cv);
    //     });
    // }    

    cartCount = currentCart.length;
}

const getVzdlCurrentProduct = (dtmProductArr, selectedInternet) => {

    let prdArray = [];
    const merchProps = getMerchPropsFromMN();
    dtmProductArr.map((currentProduct) => {
        let objProd = new Object();
        objProd.name = currentProduct.productID;
        objProd.id = currentProduct.productNumber;
        if(currentProduct.productNumber){
            let isVzForward = InHomeUtils.vzFwdOfferIds?.includes(currentProduct?.productNumber) ? true :false;
            let isMnhDiscount = ["R3727", "R2480", "R3728", "R2479"]?.includes(currentProduct.productNumber) ? true :false;
            if(isVzForward){
                updateSubFlowValue('| vfwd', 'vfwd');
            }
            if(isMnhDiscount){
                updateSubFlowValue(' | M+H', 'm+h');
            }
        }
        const categoryType =  currentProduct.prodType === "BYOPERK" ? currentProduct.prodType : InHomeUtils.isNotNull(currentProduct.type) ? currentProduct.type : currentProduct.primaryCategoryandSub;
        let merchCategoryType = categoryType?.indexOf('FTTP') != -1 ? 'plan' :  categoryType?.indexOf('BYOPERK') != -1 ? 'perk' :  categoryType?.indexOf('ROUTER') != -1 ? "accessories" : "";
        if(merchCategoryType != ''){
            objProd.merchCat = merchCategoryType;
            //objProd.merchCat = selectedInternet !==" " && InHomeUtils.isNotNull(selectedInternet)? merchCategoryType +" - "+ selectedInternet.name.replace('4.0','') : merchCategoryType;
            objProd.path = merchProps?.path;
            objProd.action = merchProps?.action;
        }        

        objProd.category = categoryType;
        objProd.offer = null;
        objProd.discount = InHomeUtils.isNotNull(currentProduct.discountID) ? currentProduct.discountID : "";
        objProd.qty = currentProduct.quantity;
        objProd.recurringPrice = currentProduct.priceRecurring;
        objProd.nonRecurringPrice = (InHomeUtils.isNotNull(currentProduct.priceType) && currentProduct?.priceType.indexOf("NRC") > -1) ? currentProduct.priceBase : "";
        objProd.line = null;
        objProd.sku = null;
        objProd.contractType = null;
        objProd.rebate = null;
        objProd.shippingCharge = (InHomeUtils.isNotNull(currentProduct.type) && (currentProduct.type === "SHFEE" || currentProduct.type === "VCPEDELIVERY" )) ? currentProduct.priceBase : null;
        objProd.shippingType = null;
        objProd.orderType = "urc"; // VCGBQA-1491 - changes
        objProd.shared = null;
        if(objProd.name !== objProd.id)
        prdArray.push(objProd);
    });
    if(prdArray.length>0){
        if(!isProdView){
            currProductsArray = prdArray;
        }
    }
    return prdArray;
}


const CalcTaxAmount = (stateInfo) => {
    let NRCTax = InHomeUtils.isNotNull(stateInfo) && stateInfo.fbeInfo && stateInfo.fbeInfo.getsoc && stateInfo.fbeInfo.getsoc.socResponse.socTotalTaxAmountNRC ? stateInfo.fbeInfo.getsoc.socResponse.socTotalTaxAmountNRC : 0;
    let RCTax = InHomeUtils.isNotNull(stateInfo) && stateInfo.fbeInfo && stateInfo.fbeInfo.getsoc && stateInfo.fbeInfo.getsoc.socResponse.socTotalTaxAmountRC ? stateInfo.fbeInfo.getsoc.socResponse.socTotalTaxAmountRC : 0;
    return parseInt(NRCTax) + parseInt(RCTax);
}

const populatingVzdlUserObject = (stateInfo) => {
    try {
        if (stateInfo.stateInfo.signIn != undefined) {
            vzdl.user.existingServices = stateInfo.stateInfo.signIn.response.services.filter(
                obj => obj.qualified == "Y").map((mapObj) => {
                    return mapObj.servicename
                }).join("|").replace("Video", "FiOSTV").replace("Voice", "FiOSVoice");
            //serviceNames.filter(obj => obj != undefined).join("|");            

            //vzdl.user.account = getEncryptValues();//stateInfo.stateInfo.signIn.response.visionCustomerId;
            //vzdl.user.customerType = stateInfo.stateInfo.signIn.response.userProfile.customerType.replace(":", "").toLowerCase();
            //change request VCGBQA-1224
            vzdl.user.customerType = stateInfo.stateInfo.signIn.response.employeeOfferExists ? "ME" : "PE";
            vzdl.user.zip = stateInfo.stateInfo.signIn.response.zipCode;
            vzdl.user.productsQualified = fProductsQualified(stateInfo.stateInfo.signIn.response.services);
            // 'ec-' + stateInfo.stateInfo.signIn.response.services.filter(
            //     obj => obj.qualified == "Y").map((mapObj) => {
            //         return mapObj.servicename
            //     }).join("|").replace("FiOSData", "efdata").replace("Video", "eftv").replace("Voice", "efphone");
            vzdl.user.accountType = stateInfo.stateInfo.signIn.response.isPrepayAccount == "Y" ? "Prepay" : "Postpaid";
            vzdl.user.tenure = convertDateToNumber(stateInfo.stateInfo.signIn.response.accountCreationDate);
        }
        if((InHomeUtils.isNotNull(stateInfo.stateInfo.signIn)) && (InHomeUtils.isNotNull(stateInfo.stateInfo.signIn.response))){
            if(stateInfo.stateInfo.signIn.response.vZWvZTCustIndicator){
                vzdl.user.customerBusiness="joint_cust";
            }
            else if(stateInfo.stateInfo.signIn.response.isVZWWireless == "Y"){
                vzdl.user.customerBusiness= "vzw_cust";
            } 
            else if (stateInfo.stateInfo.signIn.response.isVZWWireless == "N"){
                vzdl.user.customerBusiness="vzt_cust";
            }
            else{
                vzdl.user.customerBusiness= "no_cust";
            }

        }

        if (stateInfo.stateInfo.signInState != undefined)
            vzdl.user.accountType = stateInfo.stateInfo.signInState.response.isPrepayAccount == "Y" ? "Prepay" : "Postpaid";

        vzdl.user.authStatus = "logged in";
        if(stateInfo.stateInfo && stateInfo.stateInfo.signIn && stateInfo.stateInfo.signIn.response && stateInfo.stateInfo.signIn.response.addressId){
            getSHA256ValEC(stateInfo.stateInfo.signIn.response.addressId);
        }
        else{
            vzdl.user.prospect = "";
        }
        if (stateInfo.stateInfo.appState != undefined) {
            vzdl.user.session = stateInfo.stateInfo.appState.visitorId;
        }
        // vzdl.user.chatId = "";
        // vzdl.user.creditAppNum = "";   
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'populatingVzdlUserObject', "populatingVzdlUserObject:" + ex);
    }
}

export const getSHA256ValEC = async (item) => {
    let hashHex = "";
    const locusID = (item + shaKey);
    try {
        const msgUint8 = new TextEncoder().encode(locusID);                          // encode as (utf-8) Uint8Array
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);          // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer));                    // convert buffer to byte array
        hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        vzdl.user.prospect = hashHex;
    } catch (error) {
        console.error("getSHA-256 failed", error);
        vzdl.user.prospect = hashHex;
    }
};

const fProductsQualified = (productArr) => {
    let serviceQualified = '';
    if (InHomeUtils.isNotNull(productArr)) {
        let srvcs = productArr;
        serviceQualified = 'single-';
        for (let i = 0; i < srvcs.length; i++) {
            if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'FiOSData') {
                serviceQualified += serviceQualified !== 'single-' ? '+fdata' : 'fdata';
            } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Video') {
                serviceQualified += serviceQualified !== 'single-' ? '+ftv' : 'ftv';
                serviceQualified = serviceQualified.replace('single', 'double');
            } else if (srvcs[i].qualified === 'Y' && srvcs[i].servicename === 'Voice') {
                serviceQualified += (serviceQualified !== 'double-' || serviceQualified !== 'single-') ? '+fphone' : 'fphone';
                serviceQualified = serviceQualified.indexOf("single") > -1 ? serviceQualified.replace('single', 'double') : serviceQualified.replace('double', 'triple');
            }
        }
    }
    return 'ec-' + serviceQualified;
}

const convertDateToNumber = (datevalue) => {
    const d = new Date();
    const strDate = (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear();
    const date1 = new Date(datevalue);
    const date2 = new Date(strDate);
    const diffInMs = Math.abs(date1 - date2);
    return diffInMs / (1000 * 60 * 60 * 24);
}
const updatePerksToProductCurrent = () =>{
  
    let prdArray =  [];
    store.getState()?.buildProduct?.perks?.selectedPerks?.map((currentProduct) => {
        prdArray.push({
            category: currentProduct.prodType,
            name: currentProduct?.prodName,
            id: currentProduct?.prodId,
            discount: 0,
            line: 0,
            recurringPrice: currentProduct?.price,
            nonRecurringPrice: currentProduct?.price
        });
    });
    vzdl.txn.product.current = [...vzdl.txn.product.current, ...prdArray];

} 

const getProductAndOffer = () =>{
    let prdArray = [];
    store.getState()?.buildProduct?.internet?.m2mPlans?.map((currentProduct) => {
        if (currentProduct?.isprdOnProfile) {
            if(currentProduct?.id){
                if(["R3727", "R2480", "R3728", "R2479"]?.includes(currentProduct.id)){
                    updateSubFlowValue(' | M+H', 'm+h');
                }
            }
            prdArray.push({
                category: InHomeUtils.isNotNull(currentProduct?.prodType) ? currentProduct?.prodType : "",
                name: currentProduct?.name,
                id: currentProduct?.id,
                discount: 0,
                line: 0,
                recurringPrice: currentProduct?.displayPrice,
                nonRecurringPrice: currentProduct?.originalPrice
            });
            currentProduct?.specialOffers?.map((offer) => {
                if(offer?.id){
                    if(["R3727", "R2480", "R3728", "R2479"]?.includes(offer.id)){
                        updateSubFlowValue(' | M+H', 'm+h');
                    }
                }
                prdArray.push({
                    category: InHomeUtils.isNotNull(offer?.prodType) ? offer?.prodType : "",
                    name: offer?.OfferText,
                    id: offer?.id,
                    recurringPrice: offer?.BsOfferAttrValue
                });
            })
        }
    });
    return prdArray;
}
export const updatecartEvent = (event, scdetail, flow , currProduct = "" ) => {
    try {
        let selectedInternet = store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.internet.selectedProduct

        if (event == "AddtoCart" || event==="RemovefromCart") {

            //console.log('here',event,scdetail)
            // if (cartCount < cartPreviousCount) {
            //     event = "RemovefromCart";
            //     vzdl.event.value = "scRemove";
            // }(eventAction == "AddtoCart" ? prodType !="INTERNET" ? "scAdd,scOpen" : "scAdd" : "scRemove");
            // else {
            if (isFirstCartAdd == true)
                vzdl.event.value = (event === "RemovefromCart" ? "scRemove": "scOpen,scAdd") // ITT-704502
                //vzdl.event.value =  "scOpen,scAdd" // PREVIOUS VALUES
            else
                vzdl.event.value = (event==="AddtoCart" ? "scAdd": "scRemove")
            isFirstCartAdd = false;
            if (scdetail != "")
                vzdl.page.detail = scdetail;
            if(event==="RemovefromCart" && currProduct && currProduct!= ""){
                addProductCurrent(currProduct, true);
            }
        }
        else if (event == "cartView")
            vzdl.event.value = "cartView";
        else if (event == "Prodview") {
            vzdl.event.value = "prodview";
            if (scdetail != "")
                vzdl.page.detail = scdetail;
            if(currProduct && currProduct!= ""){
                addProductCurrent(currProduct)
            }
        }
        else if (event == "submitorder"){
            let isShippingFee = store && store.getState && store.getState().cart && store.getState().cart.isShippingFee;
            let returnEquipmentstate =  store && store.getState && store.getState().disconnectvalues && store.getState().disconnectvalues?.returnEquipmentCrp && store.getState().disconnectvalues?.returnEquipmentCrp.length > 0;
            let isAutoPayEnrolled = store && store.getState && store.getState()?.pfbautopay?.isVEPSCall?.isAutoPayEnrolled
            if(isShippingFee){
                vzdl.event.value = "purchase,event116,event42";
            }
            else{
                vzdl.event.value = "purchase,event116";
            }
            if(returnEquipmentstate){
                vzdl.event.value = vzdl.event.value + ",event30";
            }
            if (isAutoPayEnrolled) {
                vzdl.event.value = vzdl.event.value + ",event76";
            }
        }
        else if (event == "event11")
            vzdl.event.value = "event11";
        else if (event == "Checkout")
            vzdl.event.value = "scCheckout, event146";
        else if (event == "event11") {
            vzdl.event.value = "event11";
            event = "pageViewOmni";
        } 
        else if(event === "updateContentFragment"){
            vzdl.page.contentFragments = scdetail;
            event = "pageViewOmni";
        }
        else {
            if (event && event != "pageViewOmni") {
                vzdl.event.value = event;
                
               if (vzdl.txn.product.current?.map((product) => product.id)?.indexOf(currProduct?.id) === -1) {
                addProductCurrent(currProduct, "", selectedInternet)  //check 
              }
              else {
               vzdl.txn.product.current = vzdl.txn.product?.current?.filter((item) => item.id != currProduct?.id);
              }
                // tagging fix start
                if (event === 'scOpen,scAdd' &&
                    store.getState().buildProduct && store.getState().signIn?.response?.flowRoute === "FULLDISCONNECT") {
                    vzdl.txn.product.current = getProductAndOffer();
                    updatePerksToProductCurrent()
                    generateValueBayouCombo();
                } 
                
                // tagging fix end
            }
            else
                vzdl.event.value = "";
            event = "pageViewOmni";
        }
        if(isProdView && event !== "Prodview"){
           // vzdl.txn.product.current = currProductsArray;
          addProductCurrent(currProduct, "", selectedInternet)   
          //  updatePerksToProductCurrent()
            generateValueBayouCombo();  
         // vzdl.txn.bayouCombo = "R949"
            isProdView = false;
        }
        if(flow === "updateContentFragment"){
            sendCustomEvent(event);
        }
        else{    
            vzdl.page.contentFragments = "";
            sendCustomEvent(event);
        }        
        if (event && event == "pageViewOmni" && flow == "pega") { //for pega detail should populate only on pop up
            vzdl.page.detail = "";  
        }  
        if (event ==="scAdd" && scdetail === "" && flow ===""&& InHomeUtils.isNotNull(currProduct) ) {
            addProductCurrent(currProduct, "", selectedInternet)   
        }
                  
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'updatecartEvent', "updatecartEvent:" + ex);
    }
}

export const sendDataEvent = (accordion, event)=>{
    subFlowChange = vzdl.page.subFlow
    if(accordion.indexOf("emergency_services") > -1){
        vzdl.page.detail = "Emergency Services";
        updateSubFlowValue('| Emergency Services', 'emergency services')
    }
    
    vztag.api.dispatch("sendData", {
        name : '',
        events : event
      });
}

export const vzdlBuildProductPageEvents = (accordion, flowRoute, perkDetailName) => {
   
    try {
        vzdl.event.value = "";
        if(flowRoute !=="FULLDISCONNECT"){

        if (accordion == "toggle_internet_accor" || accordion == "toggle_internet_plan_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add internet";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_internet_router_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add router";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_internet_fne_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add network support";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_internet_techsure_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add security";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_internet_techsure_cloud_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add cloud";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_streamingserv_accor" || accordion == "toggle_streamingserv_plan_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add streaming";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_tv_accor" || accordion == "toggle_tv_plan_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add tv";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_tv_connections_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "choose set-top box";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_tv_settopbox_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add no of tvs";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_tv_recording_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add recording service";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_tv_channel_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add premium channels";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_tv_dct_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "free digital adapter";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_tv_internationalchannel_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add international channel";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_tv_ceapps_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add streaming device";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_phone_accor" || accordion == "toggle_phone_plan_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add phone";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_phone_intlcalling_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add international plans";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_phone_intlplans_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add call more countries & destinations";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "toggle_phone_existing_listing_accor") {
            vzdl.page.name = "Service Overview";
            vzdl.page.detail = "add directory listing";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "Paper Free Billing and Auto Pay") {
            vzdl.page.name = "checkout";
            vzdl.page.detail = "Paper Free Billing and Auto Pay";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "satellite TV Services") {
            vzdl.page.name = "checkout";
            vzdl.page.detail = "satellite TV Services";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "info and credit - autopay and pfb") {
            vzdl.page.name = "checkout";
            vzdl.page.detail = "info and credit - autopay and pfb";
            vzdl.page.flow = "acrdflow/am";
        }
        if (accordion == "Installation") {
            vzdl.page.name = "checkout";
            vzdl.page.detail = "Installation";
            vzdl.page.flow = "acrdflow/am";
        }
        if(accordion.indexOf("smart cart confirmation") > -1){
            vzdl.page.name = "smart cart save";
            vzdl.page.detail = accordion;
            vzdl.page.flow = "acrdflow/am";
            vzdl.event.value = "event85";
        }
        if(accordion.indexOf("smart cart save proactive") > -1){
            vzdl.page.name = "smart cart save";
            vzdl.page.detail = accordion;
            vzdl.page.flow = "acrdflow/am";
            vzdl.event.value = "event85";
        }
        if(accordion.indexOf("smart cart resave") > -1){
            vzdl.page.name = "smart cart resave";
            vzdl.page.detail = "smart cart resave";
            vzdl.page.flow = "acrdflow/am";
            vzdl.event.value = "event85";
        }
        //ITT-665479 - Fix
        if(accordion === "Pega Recommendation"){
            vzdl.page.name = "Pega Recommendation";
            vzdl.page.flow = "acrdflow/am";
            vzdl.event.value = "event117";
        }
        if(accordion.indexOf("toggle_internet_perks_accor") > -1 ){
            vzdl.page.name = "service overview";
            vzdl.page.flow = "acrdflow/am";
            vzdl.page.detail = "perks - " + perkDetailName;
        } 
         if(accordion.indexOf("toggle_internet_perks_detail_accor") > -1 ){
            vzdl.page.name = "service overview";
            vzdl.page.flow = "upgrade/renewal+ atom";
            vzdl.page.detail = "perks - home device support and protection";

        } 
        if(accordion.indexOf("toggle_internet_perks_cloud_storage_detail_accor") > -1 ){
            vzdl.page.name = "service overview";
            vzdl.page.flow = "upgrade/renewal+ atom";
            vzdl.page.detail = "perks - unlimited cloud storage";

        }
        if(accordion.indexOf("emergency_services") > -1){
            vzdl.page.detail = "Emergency Services";
        }
        if(isProdView){
            vzdl.txn.product.current = currProductsArray;
            isProdView = false;
        }
       
        generateValueBayouCombo();
        
        updatePageFlowForDisconnectFlow();
        
        sendCustomEvent("PageviewOmni");
    }   
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'vzdlBuildProductPageEvents', "vzdlBuildProductPageEvents:" + ex);
    }
}

export const vzdlSubmitOrderInit = (stateInfo) => {
    try {
        vzdl.page.name = "order confirmation";
        vzdl.txn.status = "order confirmed";
              
        updatePageFlowForDisconnectFlow();

        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.signIn) && InHomeUtils.isNotNull(stateInfo.signIn.response) && InHomeUtils.isNotNull(stateInfo.signIn.response.isVZWWireless) && stateInfo.signIn.response.isVZWWireless === "N") {
            if (stateInfo.submitOrder.isDataGig == true) {
                vzdl.page.detail = "cross-sell gig disc dlr 40";
            } else {
                vzdl.page.detail = "cross-sell non-gig disc dlr 25";
            }
        }
        else
            vzdl.page.detail = "order confirmation";

        if (InHomeUtils.isNotNull(stateInfo.buildProductState) && InHomeUtils.isNotNull(stateInfo.buildProductState.internet) && InHomeUtils.isNotNull(stateInfo.buildProductState.internet.mnhSignupIndicator)) {
            if (stateInfo.buildProductState.internet.mnhSignupIndicator == "" || stateInfo.buildProduct.internet.mnhSignupIndicator == null) {
                vzdl.page.detail = "order confirmation - mh not eligible";
            }
            if (stateInfo.buildProductState.internet.mnhSignupIndicator == "Y") {
                vzdl.page.detail = "order confirmation - mh enrolled";
            }
            if (stateInfo.buildProductState.internet.mnhSignupIndicator == "N") {
                vzdl.page.detail = "order confirmation - mh eligible";
            }
        }
        vzdl.page.flow = "acrdflow/am";
        vzdl.env.businessUnit = "Wireline";
        vzdl.txn.installOptions = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.checkoutInfo) && InHomeUtils.isNotNull(stateInfo.checkoutInfo.selDueDateType) && InHomeUtils.isNotEmpty(stateInfo.checkoutInfo.selDueDateType) ? stateInfo.checkoutInfo.selDueDateType : "";
        vzdl.txn.id = InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.appState) && InHomeUtils.isNotNull(stateInfo.appState.mon_no) ? stateInfo.appState.mon_no : "";
        if (vzdl.txn.id == "")
            vzdl.txn.id = InHomeUtils.isNotNull(stateInfo.commonState) && InHomeUtils.isNotNull(stateInfo.commonState.submitorderresponse) && InHomeUtils.isNotNull(stateInfo.commonState.submitorderresponse.mon) ? stateInfo.commonState.submitorderresponse.mon : "";
    
        vzdl.txn.cartId = vzdl.txn.id; // VCGBQA-1465 - fix
        //generateValueBayouCombo();

    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'vzdlSubmitOrderInit', "vzdlSubmitOrderInit:" + ex);
    }
}


//Get Cart Current info.
export const vzdlCurrentandOwnCart = (stateInfo) => {
   // window.vzdl = vzdl;
    try {
        if (InHomeUtils.isNotNull(stateInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartOrderDetail) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartResponse) && InHomeUtils.isNotNull(stateInfo.cartInfo.cartResponse.tierContent)) {
            let dtmProdArr = getProductObject(stateInfo.cartInfo.cartOrderDetail, stateInfo.cartInfo.cartResponse, "AF");
            vzdl.txn.product.current = getVzdlCurrentProduct(dtmProdArr);
            vzdl.event.value = "scOpen,scAdd";
            vzdl.utils.outcome = "Y";
            vzdl.page.detail = "";
            generateValueBayouCombo();

        }
    }
    catch (ex) {
      catchJSException('VZDL', visitId, 'vzdlCurrentandOwnCart', ex);
    }
}

//vzdl.txn.product.current for pega
export const VzdlCurrentPrdPega = (cartResponse) => {
    try {
        let product = [];
        let cartProducts;
        let tierprd;
        const merchProps = getMerchPropsFromMN();
        if (InHomeUtils.isNotNull(cartResponse) && InHomeUtils.isNotNull(cartResponse.tierPricing) && InHomeUtils.isNotNull(cartResponse.tierPricing.tierContent)) {
            tierprd = cartResponse.tierPricing;
            cartProducts = tierprd.tierContent;
        }

        if (cartProducts != null && cartProducts.length > 0 && cartProducts[0].sections != null && cartProducts[0].sections.section != null) {
            let bundleProd = new Object();
            if (cartResponse.orderDetail != null && cartResponse.orderDetail.bundle == true) {
                bundleProd.productNumber = cartResponse.orderDetail.bundleId;
            }
            
            if (InHomeUtils.isNotNull(cartResponse) && InHomeUtils.isNotNull(cartResponse.tierPricing) && InHomeUtils.isNotNull(cartResponse.tierPricing.tierContent)) {
                cartResponse.tierPricing.tierContent[0].sections.section.map((cartsections, index) => {
                    if (cartsections != null && cartsections.subSections != null && cartsections.subSections.subSection != null) {
                        cartsections.subSections.subSection.map((cartsubsection, index) => {
                            if (cartsubsection != null) {
                                if (cartResponse.orderDetail != null && cartResponse.orderDetail.bundle == true && cartsubsection.sectionType == 'SVCCOMPONENT') {

                                    bundleProd.name = cartsubsection.title;
                                    bundleProd.id = cartsubsection.title;

                                    let categoryType = cartsubsection ?.sectionType?.indexOf('FTTP') != -1 ? 'plan.' :  cartsubsection?.sectionType?.indexOf('BYOPERK') != -1 ? 'perk.' :  cartsubsection?.sectionType?.indexOf('ROUTER') != -1 ? "accessories." : "";
                                    if(categoryType != ''){
                                        bundleProd.merchCat = categoryType;
                                        bundleProd.path = merchProps?.path;
                                        bundleProd.action = merchProps?.action;
                                    }
                                    
                                    bundleProd.category = cartsubsection.sectionType;
                                    bundleProd.offer = "";
                                    bundleProd.discount = "";
                                    bundleProd.qty = "1";
                                    bundleProd.recurringPrice = cartsubsection.sectionTotalprice;
                                    bundleProd.nonRecurringPrice = "0";
                                    bundleProd.line = null;
                                    bundleProd.sku = null;
                                    bundleProd.contractType = null;
                                    bundleProd.rebate = null;
                                    bundleProd.shippingCharge = "0";
                                    bundleProd.shippingType = null;
                                    bundleProd.shared = null;
                                    if(bundleProd?.id){
                                        if(["R3727", "R2480", "R3728", "R2479"]?.includes(bundleProd.id)){
                                            updateSubFlowValue(' | M+H', 'm+h');
                                        }
                                    }
                                    //bundleProd.priceBase = cartsubsection.sectionTotalprice;                                
                                    product.push(bundleProd);
                                }

                                if (cartsubsection.products != null) {
                                    cartsubsection.products.map((value, index) => {
                                        if (value.prodName != null) {
                                            let prod = new Object();
                                            if (value.prodType == "FVPRIMARY") {
                                                prod.name = value.prodName.replace(/[^A-Za-z ]+/g, '');
                                            }
                                            else {
                                                prod.name = value.prodName;
                                            }
                                            prod.id = value.prodId;

                                            prod.merchCat = "";
                                            prod.category = value.prodType;
                                            prod.offer = "";
                                            prod.discount = "";
                                            prod.qty = "1";
                                            if (value.priceType == "NRC") {
                                                prod.nonRecurringPrice = value.price;
                                                prod.recurringPrice = "0";
                                            } else {
                                                prod.recurringPrice = value.price;
                                                prod.nonRecurringPrice = "0";
                                            }
                                            prod.line = null;
                                            prod.sku = null;
                                            prod.contractType = null;
                                            prod.rebate = null;
                                            prod.shippingCharge = "0";
                                            prod.shippingType = null;
                                            prod.shared = null;
                                            //prod.priceBase = value.price; 
                                            if(prod?.id){
                                                if(["R3727", "R2480", "R3728", "R2479"]?.includes(prod.id)){
                                                    updateSubFlowValue(' | M+H', 'm+h');
                                                }
                                            }                                       
                                            product.push(prod);
                                        }
                                    });
                                }

                                if (cartsubsection.promos != null) {
                                    cartsubsection.promos.map((value, index) => {
                                        let prod = new Object();
                                        prod.name = value.promoText;
                                        prod.id = value.promoId;
                                        prod.merchCat = null;
                                        prod.category = value.offerAttr;
                                        prod.offer = value.offerAttrValue;                                        
                                        prod.discount = value.promoText
                                        prod.qty = "1";
                                        prod.nonRecurringPrice = "0";
                                        prod.recurringPrice = "0";
                                        prod.line = null;
                                        prod.sku = null;
                                        prod.contractType = null;
                                        prod.rebate = null;
                                        prod.shippingCharge = "0";
                                        prod.shippingType = null;
                                        prod.shared = null;
                                        if(prod?.id){
                                            if(["R3727", "R2480", "R3728", "R2479"]?.includes(prod.id)){
                                                updateSubFlowValue(' | M+H', 'm+h');
                                            }
                                        } 
                                        product.push(prod);
                                    });
                                }
                                if (cartsubsection.promotions != null) {
                                    cartsubsection.promotions.map((value, index) => {
                                        if (value.OfferAttr && value.OfferAttr != "|NOTFORBACKEND|") {
                                            var prod = new Object();
                                            prod.name = value.name;
                                            prod.id = value.id;
                                            prod.merchCat = null;
                                            prod.category = value.prodType;
                                            if (value.offerId != null)
                                                prod.offer = value.offerId;
                                            else
                                                prod.offer = "";                                            
                                            prod.discount = value.promoText;                                            
                                            prod.qty = "1";
                                            prod.nonRecurringPrice = InHomeUtils.isNotNull(value.price) ? value.price : "0";
                                            prod.recurringPrice = "0";
                                            prod.line = null;
                                            prod.sku = null;
                                            prod.contractType = null;
                                            prod.rebate = null;
                                            prod.shippingCharge = "0";
                                            prod.shippingType = null;
                                            prod.shared = null;
                                            if(prod?.id){
                                                if(["R3727", "R2480", "R3728", "R2479"]?.includes(prod.id)){
                                                    updateSubFlowValue(' | M+H', 'm+h');
                                                }
                                            } 
                                            // if (value.promotionId != null)
                                            //     prod.promoID = value.promotionId;

                                            product.push(prod);
                                        }
                                    });
                                }

                                //====
                                if (cartsubsection?.perks != null) {
                                    cartsubsection?.perks?.map((value, index) => {                                         
                                            var prod = new Object();
                                            prod.name = value?.name;
                                            prod.id = value?.id;

                                            prod.merchCat =  'perk'; // perk
                                            prod.path = merchProps?.path;
                                            prod.action = merchProps?.action;

                                            prod.category = value?.prodType;         
                                            prod.qty = "1";
                                            prod.nonRecurringPrice = InHomeUtils.isNotNull(value?.price) ? value.price : "0";
                                            prod.recurringPrice = "0";
                                            prod.line = null;
                                            prod.sku = null;
                                            prod.contractType = null;
                                            prod.rebate = null;
                                            prod.shippingCharge = "0";
                                            prod.shippingType = null;
                                            prod.shared = null;

                                            product.push(prod);
                                      
                                    });
                                }
                                //===
                            }
                        });
                    }
                });
            }
        }

        vzdl.txn.product.current = product;
        currProductsArray = vzdl.txn.product.current;
        vzdl.event.value = "scOpen,scAdd";
        vzdl.utils.outcome = "Y";
        vzdl.page.detail = "";
        generateValueBayouCombo();

    }
    catch (ex) {
        catchJSException('VZDL', visitId, 'VzdlCurrentPrdPega', ex);
    }
}


export const populatingVzdlPegaObject = (stateInfo, isPegaBack = false, pageDetails='') => {
    //window.vzdl = vzdl;
    //console.log("bhushan pega state", stateInfo);
    try {
        if (stateInfo.stateInfo.appState != null && stateInfo.stateInfo.pegaState != null && stateInfo.stateInfo.pegaState.bundles) {
            let promoadded = "<offer type>| <offer name>| <bundleid>";
            let landingprodQual = "ec-";
            let vzwCustomerIdentifier = (stateInfo.stateInfo.pegaState.profileBundleInfo != null && stateInfo.stateInfo.pegaState.profileBundleInfo.isVZWWireless == 'Y') ? 'vzw customer' : 'non - vzw customer';
            let existingservices = "";
            let bundleDetails = stateInfo.stateInfo.pegaState.bundles.length > 0 ? stateInfo.stateInfo.pegaState.bundles[0] : null;
            let customerType = (stateInfo.stateInfo.signInState != null && stateInfo.stateInfo.signInState.response != null && stateInfo.stateInfo.signInState.response.userProfile != null) ? stateInfo.stateInfo.signInState.response.userProfile.customerType : null;            
            let spName = '';
            let dpName = '';
            let propCtgry = '';
            let propID = '';
            let offerIdentifier = '';
            var custIntent = (stateInfo.stateInfo.signInState != null && stateInfo.stateInfo.signInState.response != null) ? stateInfo.stateInfo.signInState.response.intent : null;
            var recomType = null;
            if (custIntent && custIntent.toUpperCase() == "PEGA")
                recomType = "PEGA";
            else
                recomType = "CRMM";

            let currentPlanPrice = 0;
            if (stateInfo.stateInfo.pegaState.profileBundleInfo != undefined && stateInfo.stateInfo.pegaState.profileBundleInfo.currentBundlePrice != null)
                currentPlanPrice = stateInfo.stateInfo.pegaState.profileBundleInfo.currentBundlePrice.replace('$', '');

            let bundles = stateInfo.stateInfo.pegaState.bundles;
            if (bundles && bundles.length > 0 && custIntent && custIntent.toUpperCase() == "PEGA") {
                for (let i = 0; i < bundles.length; i++) {
                    if (propCtgry == '')
                        propCtgry = bundles[i].category + "| " + bundles[i].rank;
                    else
                        propCtgry += "|" + bundles[i].category + "| " + bundles[i].rank;

                    if (propID == '')
                        propID = bundles[i].propositionId;
                    else
                        propID += "|" + bundles[i].propositionId;

                    if (offerIdentifier == '')
                        offerIdentifier = bundles[i].offerIdentifier ? bundles[i].offerIdentifier : '';
                    else
                        offerIdentifier += "|" + bundles[i].offerIdentifier ? bundles[i].offerIdentifier : '';
                }
            }

            if (bundleDetails) {
                if (bundleDetails.offerType) {
                    promoadded = promoadded.replace('<offer type>', bundleDetails.offerType);
                } else {
                    promoadded = promoadded.replace('<offer type>|', "");
                }

                if (bundleDetails.bundleType) {
                    promoadded = promoadded.replace('<bundleid>', bundleDetails.bundleType);
                } else {
                    promoadded = promoadded.replace('<bundleid>', "");
                }

                let firstoffer = null;
                if (bundleDetails.offerName) {
                    firstoffer = bundleDetails.offerName.replace('||', '');
                    promoadded = promoadded.replace('<offer name>', firstoffer);
                } else {
                    promoadded = promoadded.replace('<offer name>|', "");
                }

                // if ((window.location.href.indexOf('pegaRecommendation') > -1)){
                //     spName = 'pegaRecommendation';
                // }
                spName = 'pegaRecommendation';
                dpName = 'atom| nclick| renewal| <offer name>| service overview';

                if (dpName.indexOf('<offer type>') > -1 && bundleDetails.offerType)
                    dpName = dpName.replace('<offer type>', bundleDetails.offerType);
                if (dpName.indexOf('<offer name>') > -1 && firstoffer) {
                    dpName = dpName.replace('<offer name>', firstoffer);
                    //spName = spName.replace('<offer name>', firstoffer);
                }
            } else {
                promoadded = "";
            }

            if (customerType != null && customerType != '') {
                if (customerType.indexOf('internet') > -1)
                    existingservices += existingservices != '' ? '+FDATA' : 'FDATA';
                if (customerType.indexOf('tv') > -1)
                    existingservices += existingservices != '' ? '+FTV' : 'FTV';
                if (customerType.indexOf('voice') > -1)
                    existingservices += existingservices != '' ? '+FVOICE' : 'FVOICE';
            }

            let offerType = "";
            if (bundleDetails && bundleDetails.bundleType)
                offerType = bundleDetails.bundleType ? bundleDetails.bundleType + " | title: " : "";
            let initialOfferType = offerType;
            let val = 0;
            if (bundleDetails != null && bundleDetails.components != null) {
                bundleDetails.components.forEach(function (pkg) {
                    if (pkg !== null && pkg.type === "BASIC") {
                        landingprodQual += landingprodQual != 'ec-' ? '+eftv' : 'eftv';
                        offerType += offerType != initialOfferType ? ', Fios TV ' : 'Fios TV ';
                        offerType += pkg.productName;
                        val = val + 1;
                    }
                    if (pkg !== null && pkg.type === "FTTPD") {
                        landingprodQual += landingprodQual != 'ec-' ? '+efdata' : 'efdata';
                        offerType += offerType != initialOfferType ? ', Fios Quantum Internet ' : 'Fios Quantum Internet ';
                        offerType += pkg.productName.replace("Mbps", "");
                        val = val + 1;
                    }
                    if (pkg !== null && pkg.type === "FVPRIMARY") {
                        landingprodQual += landingprodQual != 'ec-' ? '+efphone' : 'efphone';
                        offerType += offerType != initialOfferType ? ', Fios ' : 'Fios ';
                        offerType += pkg.productName;
                        val = val + 1;
                    }
                });
                let bundleTitle = (val == 3) ? "Verizon Triple Play" : (val == 2) ? "Verizon Double Play" : (val == 1) ? "Verizon Single Play" : "";
                offerType = offerType.replace('title', bundleTitle)
            }

            let existingProduct = [];

            if (InHomeUtils.isNotNull(stateInfo.stateInfo.pegaState) && InHomeUtils.isNotNull(stateInfo.stateInfo.pegaState.profileCart) && InHomeUtils.isNotNull(stateInfo.stateInfo.pegaState.profileCart.tierPricing) && InHomeUtils.isNotNull(stateInfo.stateInfo.pegaState.profileCart.tierPricing.tierContent) ) {

                let cartProducts = stateInfo.stateInfo.pegaState.profileCart.tierPricing.tierContent;

                if (cartProducts != null && cartProducts.length > 0 && cartProducts[0].sections != null && cartProducts[0].sections.section != null) {
                    let bundleProd = new Object();
                    if (stateInfo.stateInfo.pegaState.profileCart.orderDetail != null && stateInfo.stateInfo.pegaState.pegaState.profileCart.orderDetail.bundle == true) {
                        bundleProd.productNumber = stateInfo.stateInfo.pegaState.profileCart.orderDetail.bundleId;
                    }

                    cartProducts[0].sections.section.map((cartsections, index) => {
                        if (cartsections != null && cartsections.subSections != null && cartsections.subSections.subSection != null) {
                            cartsections.subSections.subSection.map((cartsubsection, index) => {
                                if (cartsubsection != null) {
                                    if (stateInfo.stateInfo.pegaState.profileCart.orderDetail != null && stateInfo.stateInfo.pegaState.profileCart.orderDetail.bundle == true && cartsubsection.sectionType == 'SVCCOMPONENT') {
                                        bundleProd.name = cartsubsection.title;
                                        bundleProd.id = cartsubsection.title;
                                        bundleProd.category = cartsubsection.sectionType;
                                        bundleProd.recurringPrice = cartsubsection.sectionTotalprice;
                                        bundleProd.line = null;

                                        // bundleProd.productID = cartsubsection.title;
                                        // bundleProd.primaryCategoryandSub = cartsubsection.sectionType;
                                        // bundleProd.quantity = "1";
                                        // bundleProd.priceDiscount = "0";
                                        // bundleProd.priceRecurring = cartsubsection.sectionTotalprice;
                                        // bundleProd.priceBase = cartsubsection.sectionTotalprice;
                                        // bundleProd.type = cartsubsection.sectionType;
                                        existingProduct.push(bundleProd);
                                    }

                                    if (cartsubsection.products != null) {
                                        cartsubsection.products.map((value, index) => {
                                            if (value.prodName != null) {
                                                let prod = new Object();
                                                prod.name = value.prodName;
                                                prod.id = value.prodId;
                                                prod.category = value.prodType;
                                                prod.recurringPrice = value.price;
                                                prod.line = null;

                                                // prod.productID = value.prodName;
                                                // prod.productNumber = value.prodId;
                                                // prod.primaryCategoryandSub = value.prodType;
                                                // prod.quantity = "1";
                                                // prod.priceDiscount = "0";
                                                // if (value.priceType == "NRC") {
                                                //     prod.priceNonRecurring = value.price;
                                                // } else {
                                                //     prod.priceRecurring = value.price;
                                                // }
                                                // prod.priceBase = value.price;
                                                // prod.type = value.prodType;
                                                //UpdateContractforRenewal(prod);
                                                existingProduct.push(prod);
                                            }
                                        });
                                    }

                                    if (cartsubsection.promos != null) {
                                        cartsubsection.promos.map((value, index) => {
                                            let prod = new Object();
                                            prod.name = value.promoText;
                                            prod.id = value.promoId;
                                            prod.category = value.offerAttrValue;
                                            prod.recurringPrice = "0";
                                            prod.line = null;
                                            // prod.productID = value.promoText;
                                            // prod.productNumber = value.promoId;
                                            // prod.primaryCategoryandSub = value.offerAttrValue;
                                            // prod.quantity = "1";
                                            // if (value.price != null)
                                            //     prod.priceDiscount = value.price;
                                            // else
                                            //     prod.priceDiscount = "0"
                                            // prod.priceRecurring = "0";
                                            // prod.priceBase = "0";
                                            // prod.type = value.offerAttr;
                                            existingProduct.push(prod);
                                        });
                                    }
                                }
                            });
                        }
                    });
                }
            }
            //let dtmProdArr = getProductObject(stateInfo.stateInfo.cartState.cartOrderDetail, stateInfo.stateInfo.cartState.cartResponse, "AF");
            // vzdl.txn.product.current = getVzdlCurrentProduct(dtmProdArr);
            // VzdlCurrentPrdPega(stateInfo.stateInfo.cartState.cartResponse)
            //let dtmPageEvents = 'event1, event5';

            if (InHomeUtils.isNotNull(stateInfo.stateInfo.changeAppState) && InHomeUtils.isNotNull(stateInfo.stateInfo.changeAppState.activeView) && stateInfo.stateInfo.changeAppState.activeView == 'pegabundledetails') {
                spName = 'nclick| renewal| PEGA| plan details';
                dpName = 'atom| nclick| renewal| PEGA| plan details| upsell';
                //dtmPageEvents = 'event5, event20'
            }
            else if (InHomeUtils.isNotNull(stateInfo.stateInfo.changeAppState) && InHomeUtils.isNotNull(stateInfo.stateInfo.changeAppState.activeView) && stateInfo.stateInfo.changeAppState.activeView == 'review') {
                spName = 'nclick| renewal| PEGA| checkout';
                dpName = 'atom| nclick| renewal| PEGA| checkout';
                vzdl.event.value = 'scCheckout'
            }

            // var digitalData = { page: {}, addrProfile: {}, userProfile: {}, existingProduct: existingProduct, events: [] };
            // let pageEvents = {
            //     eventInfo: { eventName: "pageViewUpdate", timeStamp: new Date(), processed: { adobeAnalytics: false } },
            //     cart: {},
            //     page: { pageName: spName, detailPageName: dpName },
            //     addrProfile: {},
            //     scEvents: dtmPageEvents
            // };

            // digitalData.page.promoOfferDetails = promoadded;

            // //digitalData.page.events = dtmPageEvents;
            // digitalData.page.recommendation = recomType;
            // digitalData.page.PEGApropCtgry = propCtgry;
            // digitalData.page.PEGAPropositionID = propID;
            // digitalData.page.PEGAOfferIdentifier = offerIdentifier;

            // digitalData.addrProfile.vzwCustomerIdentifier = vzwCustomerIdentifier;

            if(InHomeUtils.isNotNull(stateInfo.stateInfo.signInState) && InHomeUtils.isNotNull(stateInfo.stateInfo.signInState.response)){
                vzdl.page.LQZip = stateInfo.stateInfo.signInState.response.zipCode;
                vzdl.user.customerType = stateInfo.stateInfo.signInState.response.employeeOfferExists ? "ME" : "PE";
                vzdl.user.zip = stateInfo.stateInfo.signInState.response.zipCode;
                vzdl.user.accountType = stateInfo.stateInfo.signInState.response.isPrepayAccount == "Y" ? "Prepay" : "Postpaid";
                vzdl.user.tenure = convertDateToNumber(stateInfo.stateInfo.signInState.response.accountCreationDate);
                vzdl.txn.shippingZip = stateInfo.stateInfo.signInState.response.zipCode;//wrong
            }
            vzdl.page.name = spName;
            vzdl.page.detailPageName = dpName;            
            vzdl.page.channelSession = stateInfo.stateInfo.appState.visitId;
            vzdl.page.detail = pageDetails ? pageDetails :"";
            vzdl.page.flow = "upgrade/renewal| atom";
            updateSubFlowValue('| pega', 'pega')
            vzdl.user.existingServices = existingservices;
            //vzdl.user.account = stateInfo.stateInfo.signInState.response.visionCustomerId;
            //vzdl.user.customerType = stateInfo.stateInfo.signInState.response.userProfile.customerType;            
            vzdl.user.productsQualified = landingprodQual;            
            vzdl.user.authStatus = "logged in";
            vzdl.user.session = stateInfo.stateInfo.appState.visitorId;            
            if(stateInfo.stateInfo && stateInfo.stateInfo.signIn && stateInfo.stateInfo.signIn.response && stateInfo.stateInfo.signIn.response.addressId){
                getSHA256ValEC(stateInfo.stateInfo.signIn.response.addressId);
            }
            else{
                vzdl.user.prospect = "";
            }
            if (stateInfo.stateInfo.cart != undefined && stateInfo.stateInfo.cart.autoPayinCart != undefined)
                vzdl.txn.autoPay = stateInfo.stateInfo.cart.autoPayinCart == true ? "Y" : "N";
            else
                vzdl.txn.autoPay = "N";
            vzdl.txn.discount = "";
            vzdl.txn.installOptions = "techvisit";//InHomeUtils.isNotNull(stateInfo.stateInfo) && InHomeUtils.isNotNull(stateInfo.stateInfo.checkoutInfo) && InHomeUtils.isNotNull(stateInfo.stateInfo.checkoutInfo.selDueDateType) && InHomeUtils.isNotEmpty(stateInfo.stateInfo.checkoutInfo.selDueDateType) ? stateInfo.stateInfo.checkoutInfo.selDueDateType : "";
            vzdl.txn.nonRecurringCharges = "0";
            
            //stateInfo.stateInfo.signInState.response.billingAddress.zip;//correct
            vzdl.txn.shippingTotal = "0";// we need to call soc everytime to get latest shipping charges
            vzdl.txn.total = currentPlanPrice;
            vzdl.txn.offer = offerType;
            vzdl.txn.recurringCharges = currentPlanPrice;
            // vzdl.txn.productsQualified = landingprodQual;
            //PRODDEF-39046 - Restricting txn.id to be populated only for order confirmation page
            if(window.location.href.includes('/summary')){
                vzdl.txn.id = stateInfo.stateInfo.appState.mon_no;
            }
            else{
                vzdl.txn.id = "";
            }
            vzdl.txn.product.owns = existingProduct;
            vzdl.txn.orderType = "urc/renewal";

            vzdl.utils.pegaCaseId = propID.replace("^", "|");
            vzdl.utils.athenaSession = "";//this is the session ID used to link to Pega Decisioning ( NBA Related) Sample value : NBA- 501000004
            vzdl.utils.outcome = "N";//Decision Outcome (‘Y’/’N (when pega offer is shown by default)’/blank)
            vzdl.utils.pegaOffer = promoadded.replace("^", "|");
            //digitalData.events.push(pageEvents);   

            let adbidArray = window.cookie?.split(";").filter(each => each.includes("adbid="))[0]
            let adbid = adbidArray && adbidArray?.split("=")[1]
            vzdl.user.account = adbid
           // if (isPegaFirstEventcalled == false) {
              //  isPegaFirstEventcalled = true;
           // }
            if(isPegaBack){
                vzdl.txn.product.current = [];
                vzdl.event.value = "";
            }
            if((InHomeUtils.isNotNull(stateInfo.stateInfo.signIn)) && (InHomeUtils.isNotNull(stateInfo.stateInfo.signIn.response))){
                if(stateInfo.stateInfo.signIn.response.vZWvZTCustIndicator){
                    vzdl.user.customerBusiness="joint_cust";
                }
                else if(stateInfo.stateInfo.signIn.response.isVZWWireless == "Y"){
                    vzdl.user.customerBusiness= "vzw_cust";
                } 
                else if (stateInfo.stateInfo.signIn.response.isVZWWireless == "N"){
                    vzdl.user.customerBusiness="vzt_cust";
                }
                else{
                    vzdl.user.customerBusiness= "no_cust";
                }
    
            }
            generateValueBayouCombo();
            sendCustomEvent("pageViewOmni");
        }
    }
    catch (ex) {
        catchJSException('change vzdl pega', "visitId", 'populatingVzdlPegaObject', ex);
    }

}

export const populatePegaPageValus = (pageName, socResponse, cartResponse) => {
    try {
        vzdl.page.name = pageName;
        if (pageName == "checkout" && socResponse != undefined) {
            vzdl.txn.taxAmt = socResponse.socTotalTaxAmountRC;
            vzdl.txn.nonRecurringCharges = socResponse.totalNonRecurringCharges;
            vzdl.txn.total = socResponse.firstBillEstimateCharges;
            vzdl.txn.recurringCharges = socResponse.subTotalMonthlyWithDiscount;
            if (InHomeUtils.isNotNull(cartResponse))
                vzdl.txn.shippingTotal = cartResponse.shippingCharge;
            else
                vzdl.txn.shippingTotal = "0";
        }
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'populatePegaPageValus', ex);
    }
}

export const populateVZDLoverlayName = (overlayName) => {
    try {
        if (overlayName == "compareplans")
            overlayName = "compare plans";
        if (overlayName == "channelLineUp")
            overlayName = "channel lineUp";
        if (overlayName == "fbe")
            overlayName = "estimate bill with charges";
        if (overlayName == "tos")
            overlayName = "terms of service";
        if (overlayName == "COMPAREPRICE")
            overlayName = "compare price";
        vzdl.page.detail = overlayName;
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'populateVZDLoverlayName', ex);
    }
}

export const populteVZDLNotification = (notification) => {
    try {
        vzdl.target.message = notification;
        targetMessageFlag = true;
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'populteVZDLNotification', ex);
    }
}

export const populteVZDLErrorCode = (code, msg, event, detailname = "") => {
    try {
        if (vzdl && vzdl.error) {
            vzdl.error.code = `${code}|${msg}`;
            if (event !== undefined || event !== '') {
                if (window && window.vzdl && window.vzdl.event && window.vzdl.event.value) {
                    window.vzdl.event.value = event;
                }
            }
            vzdl.page.detail = detailname !== "" ? detailname : "Error Page";
            sendCustomEvent('pageViewOmni');
        }
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'populteVZDLErrorCode', ex);
    }
}	

export const compareFbeAndCart = (cartResponse, fbeResponse) => {
    try {
        let cartProducts = [];
        let products = [];
        let cartSectionProduct = [];
        let fbeProducts = [];
        let isMatched = true;
        let totalMonthlyPrice = 0;
        let subTotalMonthlyWithDiscount = 0;

        // if (!!cartResponse.tierPricing && !!cartResponse.tierPricing.tierContent) {
        //     products = cartResponse.tierPricing.tierContent;
        //     cartProducts = products[0].sections.section;
        //     totalMonthlyPrice = products[0].totalMonthlyPrice;
        //     subTotalMonthlyWithDiscount = fbeResponse.subTotalMonthlyWithDiscount;
        //     if (totalMonthlyPrice.replace("$", "").toString() == subTotalMonthlyWithDiscount.replace("$", "").toString()) {
        //         cartProducts.map((cartsections, index) => {
        //             if (InHomeUtils.isNotNull(cartsections.subSections) && InHomeUtils.isNotNull(cartsections.subSections.subSection)) {
        //                 (cartsections.subSections.subSection).map((cartsubsection, index) => {
        //                     if (cartsubsection.sectionTotalprice == null || cartsubsection.sectionTotalprice.length == 0) {
        //                         if (InHomeUtils.isNotNull(cartsubsection.products)) {
        //                             cartsubsection.products.map((cartproduct, index) => {
        //                                 if (cartproduct.price != "Included") {
        //                                     var objCartPrd = new Object();
        //                                     objCartPrd.price = cartproduct.price.replace("$", "").toString();//price
        //                                     objCartPrd.title = cartproduct.prodName;
        //                                     cartSectionProduct.push(objCartPrd);
        //                                 }
        //                             })
        //                         }
        //                     } else {
        //                         var objCartPrd = new Object();
        //                         objCartPrd.title = cartsubsection.title;//title
        //                         objCartPrd.price = cartsubsection.sectionTotalprice.replace("$", "").toString();//price
        //                         cartSectionProduct.push(objCartPrd);
        //                     }
        //                 })
        //             }
        //         })
        //         if (!!fbeResponse && (!!fbeResponse.mrcProducts || !!fbeResponse.nrcProducts)) {
        //             fbeResponse.mrcProducts.map((mcrPrd, index) => {
        //                 var objMcrPrd = new Object();
        //                 objMcrPrd.title = mcrPrd.productname;
        //                 objMcrPrd.price = mcrPrd.price.toString();
        //                 fbeProducts.push(objMcrPrd);
        //             })
        //             fbeResponse.nrcProducts.map((nrcPrd, index) => {
        //                 var objnrcPrd = new Object();
        //                 objnrcPrd.title = nrcPrd.productname;
        //                 objnrcPrd.price = nrcPrd.price.toString();
        //                 fbeProducts.push(objnrcPrd);
        //             })
        //         }
        //         for (var i = 0; i < cartSectionProduct.length; i++) {
        //             if (isMatched == false) {
        //                 break;
        //             }
        //             for (var j = 0; j < fbeProducts.length; j++) {
        //                 if (cartSectionProduct[i].title == fbeProducts[j].title && cartSectionProduct[i].price == fbeProducts[j].price) {
        //                     isMatched = true;
        //                     //fbeProducts.splice(i);   
        //                     break;
        //                 } else {
        //                     isMatched = false;
        //                 }
        //             }
        //         }
        //     }
        //     else
        //         isMatched = false;
        // }
        if (!!cartResponse.tierPricing && !!cartResponse.tierPricing.tierContent) {
            totalMonthlyPrice = cartResponse.tierPricing.tierContent[0].totalMonthlyPrice;
            subTotalMonthlyWithDiscount = fbeResponse.subTotalMonthlyWithDiscount;
            if (totalMonthlyPrice.replace("$", "").toString() == subTotalMonthlyWithDiscount.replace("$", "").toString()) {
                isMatched = true;
            }
            else {
                isMatched = false;
            }
        }
        if (isMatched) {
            updateSCTags("dollar values matched");
        } else {
            updateSCTags("dollar values not matched");
        }
    }
    catch (ex) {
        catchJSException('change vzdl', "visitId", 'comareFbeAndCart', ex.message);
    }
}

var retrySendCustomEventCount = 0;
const sendCustomEvent = (evt) => {
    if(subFlowChange!= 'none'){
        vzdl.page.subFlow = subFlowChange
        subFlowChange = 'none'
    }
    if(targetMessageFlag){
        targetMessageFlag  = false;
    }
    else{
        vzdl.target.message = '';
    }
    //console.log("BHushan event hit", evt);
    if (InHomeUtils.isNotNull(vzdl))
        window.vzdl = vzdl;
    retrySendCustomEventCount = 0;
    updatePageFlowForDisconnectFlow();     
    if (window.dtm_doplugins && vzdl && vzdl.page && vzdl.page.name) {
        try {
            if (document.createEvent && document.body.dispatchEvent) {
                var event = document.createEvent('Event');
                event.initEvent(evt, true, true);
                document.body.dispatchEvent(event);
                setTimeout(() => {
                    vzdl.target.message = "";
                }, 1000);
            } else if (window.CustomEvent && document.body.dispatchEvent) {
                var ev = new CustomEvent(evt, {
                    bubbles: true,
                    cancelable: true
                });
                document.body.dispatchEvent(ev);
                setTimeout(() => {
                    vzdl.target.message = "";
                }, 1000);
            }
        } catch (e) {

        }
        //vzdl.target.message = "";//update blank for new event
    }
    else {
        setTimeout(() => { retrySendCustomEvent(evt); }, 500);
    }
}

const retrySendCustomEvent = (evt) => {
    retrySendCustomEventCount = retrySendCustomEventCount++;
    if (window.dtm_doplugins) {
        sendCustomEvent(evt);
    } else if (retrySendCustomEventCount < 5) {
        setTimeout(() => { retrySendCustomEvent(evt); }, 500);
    }
}

export const updateVzdlSCTags = (linkName) => {
    try {
        if(vzdl && vzdl.page && vzdl.page.name){
            window.scLinkTrackID && window.scLinkTrackID(linkName);
        }
    } catch (ex) {
        console.log("updateVzdlSCTags" + ex.message);
        catchJSException('LaunchScript', "visitId", 'updateVzdlSCTags', "updateVzdlSCTags : " + ex);
    }
}

// Created for Datatrack links - tagging
export const dataTrack = (type, name) => {
    return JSON.stringify({
      type,
      name
    });
  }


export const addProductCurrent = (product, noProdView = false, selectedInternet) => {
    let prdArray = [];
    let flowType = store && store.getState && store.getState().app && store.getState().app.flowType;
    if (product.prodType === Service.flashOffer) {
        prdArray.push({
            "productID": product.OfferText,
            "discountID": product.OfferText,
            "productNumber": product.id,
            "primaryCategoryandSub": "DISCOUNT",
            "priceDiscount": "0",
            "priceRecurring": "0",
            "priceBase": "0",
            "type": product.BsOfferAttr,
            "quantity": "1",
        })
    }
    else {
        const merchProps = getMerchPropsFromMN();
        let merchCategoryType =  product?.productType ==='BYOPERK'? 'perk': product?.prodType?.indexOf('FTTP') != -1 ? 'plan' : product?.prodType?.indexOf('BYOPERK') != -1 ? 'perk' : product?.prodType?.indexOf('ROUTER') != -1 ? "accessories" : ""; 
        prdArray.push({
            "productID":  product?.productType ==='BYOPERK'? product.name : getPrdName(product, flowType),
            "discountID": "",
            "productNumber": product.id,
            "primaryCategoryandSub": product.prodType === "PPP" ? getVasCategory(product) : prdCategoryInfo(product.prodType, flowType, product),
            "priceBase": calcprdBasePrice(product),
            "priceDiscount": "0",
            "quantity": (InHomeUtils.isNotNull(product.prodType) && product.prodType === Service.streamDevCount) ? product.unitCount : "1",
            "priceRecurring": ((InHomeUtils.isNotNull(product.prodType) && product.prodType.indexOf("NRC") > -1) || (InHomeUtils.isNotNull(product.keyword) && product.keyword.indexOf("FDV_BTRY_CHARGED") > -1)) ? "0" : calcprdBasePrice(product),
            "prodType": product?.productType ==='BYOPERK' ? product?.productType :(InHomeUtils.isNotNull(product.prodType)) ? product.prodType : "",
            ...(merchCategoryType != '' && {
                'merchCat': merchCategoryType,
                'path': merchProps?.path,
                'action': merchProps?.action
            }),
        });
    }

    if(prdArray.length> 0){
        /*if(!noProdView){
            isProdView = true;
        }*/

        //ITT-690346 fix
        const currentList = getVzdlCurrentProduct(prdArray, selectedInternet);
       // if ((vzdl?.txn?.product?.current?.map((product) => product.id))?.indexOf(currentList?.[0]?.id) === -1) {
           // vzdl.txn.product.current = [...vzdl.txn.product.current, ...currentList];
       // }

        generateValueBayouCombo();

    }
}

export const setPegaButtonStatus = () =>{
    isPegaViewAllFlag = true;
}

export const updateNameValue = (val, event) => {
    if(val)
    {
        vzdl.page.name = val;
        vzdl.page.event = event 
        sendCustomEvent("pageViewOmni");        
    } 
    else if(!val)
    {
        vzdl.page.name = '';
    }
}

export const updateTxnvalue = (val) => {
    if(val)
        {
            vzdl.txn.planChanges = val;
        }
        else if(!val)
        {
            vzdl.page.name = '';
        }
}
export const updateMessageValue = (messagevalue="") => {
    vzdl.target.message = messagevalue?messagevalue :"";
    targetMessageFlag = messagevalue ? true : targetMessageFlag;
}

export const updateVzdlSCCustomEvent = (objName, eventName, updatedTags, otherVzdlObjects = false, abTestValue = "", skipEvent=false, notification = "", currProduct = "", noOfInstallDays = "", detail="") => {

    if (vzdl && vzdl.error && vzdl.error.code !== "") {
        vzdl.error.code = "";
    }
    if(eventName === "sendData" && vzdl.page.subFlow!= ''){
        subflowChange = vzdl.page.subFlow
    }
    
    if(noOfInstallDays != ""){
        vzdl.txn.noOfInstallDays = noOfInstallDays;
    }
    else{
        vzdl.txn.noOfInstallDays = '';
    }
    if(updatedTags.indexOf("subflow") > -1){
       // vzdl.page.subFlow = scVzdlDataDetails[objName].subFlow
        let mm3Qualified = (store && store.getState() && store.getState().buildProduct && store.getState().buildProduct.internet && store.getState().buildProduct.internet.mm3Qualified) || (window.sessionStorage?.mm3Qualified === true);
        if(vzdl.page.subFlow != '' && !mm3Qualified){
            vzdl.page.subFlow += '|classic';
        }
    }  
    
   
    // VCGBQA-1466 - changes
    if (updatedTags.indexOf("notification") > -1) {
       vzdl.target.message = notification;
       targetMessageFlag = true;
    }else{
       vzdl.target.message = "";
    }

   
    if (abTestValue !== "") {
        vzdl.target.abTest = '';
    }

        
    

    if (otherVzdlObjects) {
        vzdlErrorUpdate("", otherVzdlObjects);
    }
    else {
       
       // customEventUpdate(tempVzdlSCData, eventName, objName);
        sendCustomEvent("pageViewOmni")
    }
}
export const updateSubFlowValue = (val, excludeVal = '') => {
    if(val)
    {
        if(excludeVal !== ''){
            if(!(vzdl.page.subFlow.toLowerCase().includes(excludeVal))){
                vzdl.page.subFlow = vzdl.page.subFlow + val;
            }
        }
        else{
            vzdl.page.subFlow = vzdl.page.subFlow + val;
        }
    }
}
